/* eslint-disable @trello/disallow-filenames */
import { SavedSearchModel } from 'app/gamma/src/types/models';

import { TrelloStorage } from '@trello/storage';
import { getLastMemberId } from '../last-session';

export const SIDEBAR_STORAGE_PREFIX = 'sidebarState';
const initialState: SidebarValues = {};

export interface SidebarValues {
  readonly collapsedDrawerSections?: string[];
  readonly idRecentBoards?: string[];
  readonly pinBoardsListSidebar?: boolean;
  readonly showBoardsListSidebar?: boolean;
  readonly savedSearches?: SavedSearchModel[];
}

export const getSidebarValues = (): SidebarValues | null => {
  let retVal = null;

  if (TrelloStorage.isEnabled()) {
    const idMe = getLastMemberId();

    if (idMe) {
      const storageKey = `${SIDEBAR_STORAGE_PREFIX}-${idMe}`;
      retVal = TrelloStorage.get(storageKey);

      if (retVal === null || typeof retVal !== 'object') {
        // initialize it in case of invalid state
        TrelloStorage.set(storageKey, initialState);
        retVal = TrelloStorage.get(storageKey);
      }
    }
  }

  return retVal;
};

export const setSidebarValues = (state: SidebarValues) => {
  if (TrelloStorage.isEnabled()) {
    const idMe = getLastMemberId();
    if (idMe) {
      const storageKey = `${SIDEBAR_STORAGE_PREFIX}-${idMe}`;
      TrelloStorage.set(storageKey, state);
    }
  }
};
